import { jsx as _jsx } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo, useMemo } from "react";
import { CustomField } from "~/components/CustomField";
import { SelectChipRemoveButton } from "~/components/Select/components/SelectChipRemoveButton";
import { Select } from "~/components/Select/Select";
import { CUSTOM_FIELD_SELECT_COMPONENT } from "~/constants/testIDs";
export const CustomFieldSelect = /*#__PURE__*/ memo((param)=>{
    let { field, cfOptions, className, ...rest } = param;
    const selectedOptions = useMemo(()=>{
        if (field.value) {
            return [
                {
                    value: field.value.id,
                    label: field.value.value,
                    meta: {
                        color: field.value.color.name
                    }
                }
            ];
        }
        if (field.values) {
            return field.values.map((fieldValue)=>({
                    value: fieldValue.id,
                    label: fieldValue.value,
                    meta: {
                        color: fieldValue.color.name
                    }
                }));
        }
        return [];
    }, [
        field
    ]);
    const options = useMemo(()=>{
        if (!!cfOptions) {
            return cfOptions.data.map((fieldValue)=>({
                    value: fieldValue.id,
                    label: fieldValue.value,
                    meta: {
                        color: fieldValue.color.name
                    }
                }));
        } else {
            return [];
        }
    }, [
        cfOptions
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        ...rest,
        closeMenuOnSelect: field.type.title === CustomFieldTypeName.singleSelect,
        "data-testid": "".concat(CUSTOM_FIELD_SELECT_COMPONENT, "-").concat(field.name),
        options: options,
        placeholder: "None",
        selectedOptions: selectedOptions,
        isSearchable: true,
        isSticky: true,
        chipRenderer: (chip, removeSelectedItem, meta)=>{
            var _chip_meta;
            return /*#__PURE__*/ _jsx(CustomField, {
                className: "mb-1 mr-1",
                field: {
                    id: chip.value,
                    color: {
                        name: chip === null || chip === void 0 ? void 0 : (_chip_meta = chip.meta) === null || _chip_meta === void 0 ? void 0 : _chip_meta.color
                    },
                    value: chip.label
                },
                suffix: (meta === null || meta === void 0 ? void 0 : meta.isOpen) ? /*#__PURE__*/ _jsx(SelectChipRemoveButton, {
                    chip: chip,
                    onClick: removeSelectedItem
                }) : undefined
            });
        },
        listItemRenderer: (props)=>{
            var _props_meta;
            return /*#__PURE__*/ _jsx("div", {
                className: "rounded p-2 hover:bg-grey-4",
                children: /*#__PURE__*/ _jsx(CustomField, {
                    field: {
                        id: props.value,
                        color: {
                            name: props === null || props === void 0 ? void 0 : (_props_meta = props.meta) === null || _props_meta === void 0 ? void 0 : _props_meta.color
                        },
                        value: props.label
                    }
                })
            });
        },
        className: tailwindMerge("w-full [&_.placeholder]:text-14", className),
        maxDropdownHeight: 300,
        isSingleSelect: field.type.title === CustomFieldTypeName.singleSelect,
        isClearable: true,
        hideClearWhenNotFocused: true,
        size: "large"
    });
});
CustomFieldSelect.displayName = "CustomFieldSelect";
